export { default as TableCellHead } from './TableCellHead'
